export default "__VITE_ASSET__CSqyesD6__"